(function () {
  const selector = '[data-taili-ugc]';

  function init(root) {
    if (!root || root.dataset.ugcReady === 'true') return;

    const track = root.querySelector('[data-ugc-track]');
    const cards = Array.from(root.querySelectorAll('[data-ugc-card]'));
    const previous = root.querySelector('[data-ugc-prev]');
    const next = root.querySelector('[data-ugc-next]');
    const current = root.querySelector('[data-ugc-current]');
    const progress = root.querySelector('[data-ugc-progress]');
    const modal = root.querySelector('[data-ugc-modal]');
    const modalStage = root.querySelector('[data-ugc-modal-stage]');
    const modalClose = root.querySelector('.taili-ugc__modal-close');

    if (!track || cards.length === 0) return;

    root.dataset.ugcReady = 'true';

    const pad = (number) => String(number).padStart(2, '0');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let frame = null;
    let activeMedia = null;
    let activePlayer = null;
    let activeTrigger = null;

    function closeModal(restoreFocus = true) {
      if (!modal || modal.hidden) return;

      if (activePlayer?.tagName === 'VIDEO') activePlayer.pause();
      if (activePlayer?.matches('[data-ugc-embed]')) activePlayer.removeAttribute('src');

      if (activeMedia && activePlayer) {
        const poster = activeMedia.querySelector('[data-ugc-poster]');
        activeMedia.insertBefore(activePlayer, poster || null);
      }

      modal.hidden = true;
      document.body.classList.remove('taili-ugc-modal-open');

      if (restoreFocus && activeTrigger) activeTrigger.focus();
      activeMedia = null;
      activePlayer = null;
      activeTrigger = null;
    }

    async function openModal(media, trigger) {
      if (!modal || !modalStage) return;

      const player = media.querySelector('video, [data-ugc-embed]');
      if (!player) return;

      stopAll(media);
      activeMedia = media;
      activePlayer = player;
      activeTrigger = trigger;
      modalStage.appendChild(player);
      modal.hidden = false;
      document.body.classList.add('taili-ugc-modal-open');
      modalClose?.focus();

      if (player.matches('[data-ugc-embed]') && player.dataset.src) {
        player.src = player.dataset.src;
      } else if (player.tagName === 'VIDEO') {
        try {
          await player.play();
        } catch (error) {
          closeModal(false);
        }
      }
    }

    function stopAll(except) {
      if (activeMedia && activeMedia !== except) closeModal(false);

      root.querySelectorAll('[data-ugc-media]').forEach((media) => {
        if (media === except) return;
        media.classList.remove('is-playing');

        const video = media.querySelector('video');
        const embed = media.querySelector('[data-ugc-embed]');
        if (video) video.pause();
        if (embed) embed.removeAttribute('src');
      });
    }

    function getClosestIndex() {
      const trackLeft = track.getBoundingClientRect().left;
      let closestIndex = 0;
      let closestDistance = Infinity;

      cards.forEach((card, index) => {
        const distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    function update() {
      frame = null;
      const index = getClosestIndex();
      const maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
      const ratio = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
      const visibleRatio = Math.min(track.clientWidth / track.scrollWidth, 1);

      if (current) current.textContent = pad(index + 1);
      if (previous) previous.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= maxScroll - 2;
      if (progress) {
        progress.style.width = `${Math.max(visibleRatio * 100, 12)}%`;
        progress.style.transform = `translateX(${ratio * (100 / visibleRatio - 100)}%)`;
      }
    }

    function requestUpdate() {
      if (frame !== null) return;
      frame = window.requestAnimationFrame(update);
    }

    function move(direction) {
      closeModal(false);
      stopAll();
      const index = getClosestIndex();
      const targetIndex = Math.max(0, Math.min(cards.length - 1, index + direction));
      cards[targetIndex].scrollIntoView({
        behavior: reduceMotion.matches ? 'auto' : 'smooth',
        block: 'nearest',
        inline: 'start'
      });
    }

    previous?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
    track.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });

    root.addEventListener('click', (event) => {
      if (event.target.closest('[data-ugc-modal-close]')) {
        closeModal();
        return;
      }

      const playButton = event.target.closest('[data-ugc-play]');
      if (!playButton || !root.contains(playButton)) return;

      const media = playButton.closest('[data-ugc-media]');
      if (!media) return;
      openModal(media, playButton);
    });

    document.addEventListener('keydown', (event) => {
      if (!modal || modal.hidden) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
        return;
      }

      if (event.key !== 'Tab') return;
      const focusable = Array.from(modal.querySelectorAll('button:not(:disabled), video[controls], iframe, [href]'));
      if (focusable.length === 0) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    root.querySelectorAll('video').forEach((video) => {
      video.addEventListener('ended', () => {
        if (video === activePlayer) closeModal(false);
      });
    });

    update();
  }

  function initAll(scope) {
    if (scope?.matches?.(selector)) init(scope);
    scope?.querySelectorAll?.(selector).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
